import useNavigate from 'Hooks/useNavigate';
import logo_white from '_assets/img/kan-logo-white.png';
import logo_black from '_assets/img/kan-logo.png';

import { FC } from 'react';
import './style.scss';

type Prop = { color?: 'black' | 'white'; onClick?: () => void };

const Logo: FC<Prop> = ({ color = 'black', onClick }): React.JSX.Element => {
    const navigate = useNavigate();
    const logoSrc = color == 'black' ? logo_black : logo_white;
    return (
        <div onClick={() => (onClick ? onClick() : navigate('/'))}>
            <img className="top-logo" src={logoSrc} alt="Knit&Note" />
        </div>
    );
};

export default Logo;
